const TrackingCalendarEventViewStateConstants = {
    stateName: "trackingCalendarEventView"
};

export default Object.freeze(TrackingCalendarEventViewStateConstants);


//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-calendar-view/TrackingCalendarEventViewConstants.js
// module id = htdA
// module chunks = 1